/**
 * Utility functions for WhatsApp integration
 */
/**
 * Format phone number to E.164 standard for WhatsApp
 * Removes spaces, dashes, and other non-numeric characters
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  // Remove all non-numeric characters except the leading +
  return phoneNumber.replace(/[^0-9+]/g, '')
}
/**
 * Generate a WhatsApp message based on parameters
 */
export interface WhatsAppMessageParams {
  recipientName?: string
  senderName?: string
  context?: string
  position?: string
}
export const generateWhatsAppMessage = (
  params: WhatsAppMessageParams = {},
): string => {
  const {
    recipientName = 'Mona',
    senderName = '',
    context = 'healthcare',
    position = 'Singapore',
  } = params
  const message = `Hi ${recipientName}!
I saw your digital CV and I'm impressed with your Finnish nursing expertise and multicultural perspective. I'd love to discuss how you might contribute to our ${context} team in ${position}.
Could we schedule some time to talk about potential opportunities?
${senderName ? `Best regards,\n${senderName}` : 'Best regards'}`
  return message
}
/**
 * Create a WhatsApp URL with pre-populated message
 */
export const createWhatsAppUrl = (
  phoneNumber: string,
  message: string,
): string => {
  const formattedPhone = formatPhoneNumber(phoneNumber)
  const encodedMessage = encodeURIComponent(message)
  return `https://wa.me/${formattedPhone.replace('+', '')}?text=${encodedMessage}`
}
